import { FONTS, LOGO } from '../../config/app-config';
// ──────────────────────────────────────────────────────────────
// src/components/dialogs/LegacyLoader.js
// ──────────────────────────────────────────────────────────────
import React from 'react';
import { CssBaseline, Box, CircularProgress, Typography } from '@mui/material';

/**
 * Full‑screen spinner that is shown while a legacy link
 * is being translated into the modern routing scheme.
 */
export default function LegacyLoader() {
    return (
        <>
            <CssBaseline />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                    textAlign: 'center',
                }}
            >
                <Box
                    component="img"
                    src={LOGO.light}
                    alt={LOGO.alt}
                    sx={{
                        width: 250,
                        height: 'auto',
                        mb: 4,
                    }}
                />
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <CircularProgress sx={{ mr: 2 }} />
                    <Typography sx={{ fontFamily: FONTS.body }}>
                        Resolving legacy link …
                    </Typography>
                </Box>
            </Box>
        </>
    );
}

